module.exports = __webpack_public_path__ + "img/logo_3.4b7f38bf.png";